<template>
    <div class="d-flex justify-content-end right-buttons">
        <slot></slot>
    </div>
</template>
<script>
export default {
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
<style scoped>
.right-buttons > * {
    margin-left: 10px;
}
</style>
